import { useDispatch, useSelector } from 'react-redux';

// Typed hooks - Redux Toolkit ile kullanım için
export const useAppDispatch = () => useDispatch();
export const useAppSelector = useSelector;

